import React from "react";
import { Hooks } from "@xt/xtbase";
const {useTranslation} = Hooks;
import styles from "./index.module.less";

const NoData = ({height=50}) => {
  const t = useTranslation();
  return <div className={styles["app-div-nodata"]} style={{height:height+"px"}}>
    <div>{ t("home.noData") }</div>
  </div>;
}
export default NoData;